import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_679e0403 from 'nuxt_plugin_plugin_679e0403' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_15f876cb from 'nuxt_plugin_plugin_15f876cb' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_toastplugin9807e482_293b284c from 'nuxt_plugin_toastplugin9807e482_293b284c' // Source: ./toast.plugin.9807e482.js (mode: 'all')
import nuxt_plugin_editorplugin0ae4b65f_bbcceec0 from 'nuxt_plugin_editorplugin0ae4b65f_bbcceec0' // Source: ./editor.plugin.0ae4b65f.js (mode: 'all')
import nuxt_plugin_radiobuttonplugin565a2cc5_1ea34db6 from 'nuxt_plugin_radiobuttonplugin565a2cc5_1ea34db6' // Source: ./radiobutton.plugin.565a2cc5.js (mode: 'all')
import nuxt_plugin_messageplugin33858a42_2ca0bfd2 from 'nuxt_plugin_messageplugin33858a42_2ca0bfd2' // Source: ./message.plugin.33858a42.js (mode: 'all')
import nuxt_plugin_textareaplugin482606a8_334c4bb3 from 'nuxt_plugin_textareaplugin482606a8_334c4bb3' // Source: ./textarea.plugin.482606a8.js (mode: 'all')
import nuxt_plugin_dialogplugin01c1bc7a_a196d8e0 from 'nuxt_plugin_dialogplugin01c1bc7a_a196d8e0' // Source: ./dialog.plugin.01c1bc7a.js (mode: 'all')
import nuxt_plugin_passwordpluginf4fa0a66_0f693646 from 'nuxt_plugin_passwordpluginf4fa0a66_0f693646' // Source: ./password.plugin.f4fa0a66.js (mode: 'all')
import nuxt_plugin_checkboxpluginba69ec16_513da74a from 'nuxt_plugin_checkboxpluginba69ec16_513da74a' // Source: ./checkbox.plugin.ba69ec16.js (mode: 'all')
import nuxt_plugin_buttonplugin8293ec38_388e98a9 from 'nuxt_plugin_buttonplugin8293ec38_388e98a9' // Source: ./button.plugin.8293ec38.js (mode: 'all')
import nuxt_plugin_multiselectpluginbdf6e966_0336df67 from 'nuxt_plugin_multiselectpluginbdf6e966_0336df67' // Source: ./multiselect.plugin.bdf6e966.js (mode: 'all')
import nuxt_plugin_dropdownplugin4a0ba8c3_070b319b from 'nuxt_plugin_dropdownplugin4a0ba8c3_070b319b' // Source: ./dropdown.plugin.4a0ba8c3.js (mode: 'all')
import nuxt_plugin_columnplugin5554d908_ae839bc0 from 'nuxt_plugin_columnplugin5554d908_ae839bc0' // Source: ./column.plugin.5554d908.js (mode: 'all')
import nuxt_plugin_datatableplugin54980788_711c24f9 from 'nuxt_plugin_datatableplugin54980788_711c24f9' // Source: ./datatable.plugin.54980788.js (mode: 'all')
import nuxt_plugin_inputtextplugin5230fbe2_6cc7e328 from 'nuxt_plugin_inputtextplugin5230fbe2_6cc7e328' // Source: ./inputtext.plugin.5230fbe2.js (mode: 'all')
import nuxt_plugin_configplugin2348dc18_7f33ae45 from 'nuxt_plugin_configplugin2348dc18_7f33ae45' // Source: ./config.plugin.2348dc18.js (mode: 'all')
import nuxt_plugin_axios_62bbdb99 from 'nuxt_plugin_axios_62bbdb99' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_amplifyconfig_4d66aab6 from 'nuxt_plugin_amplifyconfig_4d66aab6' // Source: ../plugins/amplify-config.js (mode: 'all')
import nuxt_plugin_amplifycomponents_3b5021e2 from 'nuxt_plugin_amplifycomponents_3b5021e2' // Source: ../plugins/amplify-components.js (mode: 'all')
import nuxt_plugin_axios_673c6d87 from 'nuxt_plugin_axios_673c6d87' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_appui_4329c131 from 'nuxt_plugin_appui_4329c131' // Source: ../plugins/app-ui.js (mode: 'all')
import nuxt_plugin_filter_13ed0f0e from 'nuxt_plugin_filter_13ed0f0e' // Source: ../plugins/filter.js (mode: 'all')
import nuxt_plugin_vuexpersist_13f465a2 from 'nuxt_plugin_vuexpersist_13f465a2' // Source: ../plugins/vuex-persist (mode: 'client')
import nuxt_plugin_eventbus_2faefc80 from 'nuxt_plugin_eventbus_2faefc80' // Source: ../plugins/event-bus.js (mode: 'all')
import nuxt_plugin_appservices_65c090f7 from 'nuxt_plugin_appservices_65c090f7' // Source: ../plugins/app-services.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Service Counter","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_679e0403 === 'function') {
    await nuxt_plugin_plugin_679e0403(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_15f876cb === 'function') {
    await nuxt_plugin_plugin_15f876cb(app.context, inject)
  }

  if (typeof nuxt_plugin_toastplugin9807e482_293b284c === 'function') {
    await nuxt_plugin_toastplugin9807e482_293b284c(app.context, inject)
  }

  if (typeof nuxt_plugin_editorplugin0ae4b65f_bbcceec0 === 'function') {
    await nuxt_plugin_editorplugin0ae4b65f_bbcceec0(app.context, inject)
  }

  if (typeof nuxt_plugin_radiobuttonplugin565a2cc5_1ea34db6 === 'function') {
    await nuxt_plugin_radiobuttonplugin565a2cc5_1ea34db6(app.context, inject)
  }

  if (typeof nuxt_plugin_messageplugin33858a42_2ca0bfd2 === 'function') {
    await nuxt_plugin_messageplugin33858a42_2ca0bfd2(app.context, inject)
  }

  if (typeof nuxt_plugin_textareaplugin482606a8_334c4bb3 === 'function') {
    await nuxt_plugin_textareaplugin482606a8_334c4bb3(app.context, inject)
  }

  if (typeof nuxt_plugin_dialogplugin01c1bc7a_a196d8e0 === 'function') {
    await nuxt_plugin_dialogplugin01c1bc7a_a196d8e0(app.context, inject)
  }

  if (typeof nuxt_plugin_passwordpluginf4fa0a66_0f693646 === 'function') {
    await nuxt_plugin_passwordpluginf4fa0a66_0f693646(app.context, inject)
  }

  if (typeof nuxt_plugin_checkboxpluginba69ec16_513da74a === 'function') {
    await nuxt_plugin_checkboxpluginba69ec16_513da74a(app.context, inject)
  }

  if (typeof nuxt_plugin_buttonplugin8293ec38_388e98a9 === 'function') {
    await nuxt_plugin_buttonplugin8293ec38_388e98a9(app.context, inject)
  }

  if (typeof nuxt_plugin_multiselectpluginbdf6e966_0336df67 === 'function') {
    await nuxt_plugin_multiselectpluginbdf6e966_0336df67(app.context, inject)
  }

  if (typeof nuxt_plugin_dropdownplugin4a0ba8c3_070b319b === 'function') {
    await nuxt_plugin_dropdownplugin4a0ba8c3_070b319b(app.context, inject)
  }

  if (typeof nuxt_plugin_columnplugin5554d908_ae839bc0 === 'function') {
    await nuxt_plugin_columnplugin5554d908_ae839bc0(app.context, inject)
  }

  if (typeof nuxt_plugin_datatableplugin54980788_711c24f9 === 'function') {
    await nuxt_plugin_datatableplugin54980788_711c24f9(app.context, inject)
  }

  if (typeof nuxt_plugin_inputtextplugin5230fbe2_6cc7e328 === 'function') {
    await nuxt_plugin_inputtextplugin5230fbe2_6cc7e328(app.context, inject)
  }

  if (typeof nuxt_plugin_configplugin2348dc18_7f33ae45 === 'function') {
    await nuxt_plugin_configplugin2348dc18_7f33ae45(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_62bbdb99 === 'function') {
    await nuxt_plugin_axios_62bbdb99(app.context, inject)
  }

  if (typeof nuxt_plugin_amplifyconfig_4d66aab6 === 'function') {
    await nuxt_plugin_amplifyconfig_4d66aab6(app.context, inject)
  }

  if (typeof nuxt_plugin_amplifycomponents_3b5021e2 === 'function') {
    await nuxt_plugin_amplifycomponents_3b5021e2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_673c6d87 === 'function') {
    await nuxt_plugin_axios_673c6d87(app.context, inject)
  }

  if (typeof nuxt_plugin_appui_4329c131 === 'function') {
    await nuxt_plugin_appui_4329c131(app.context, inject)
  }

  if (typeof nuxt_plugin_filter_13ed0f0e === 'function') {
    await nuxt_plugin_filter_13ed0f0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_13f465a2 === 'function') {
    await nuxt_plugin_vuexpersist_13f465a2(app.context, inject)
  }

  if (typeof nuxt_plugin_eventbus_2faefc80 === 'function') {
    await nuxt_plugin_eventbus_2faefc80(app.context, inject)
  }

  if (typeof nuxt_plugin_appservices_65c090f7 === 'function') {
    await nuxt_plugin_appservices_65c090f7(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
